import axios from 'axios';

const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'https://beta.wigal.com.gh/api/' });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear local storage on 401 errors
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Only redirect to login if not already there
      if (!window.location.href.includes('/login')) {
        window.location.pathname = '/login';
      }
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

// Request interceptor to add token
axiosServices.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosServices;
